
    import './styles.scoped.css';
    export default {
  "split-panel-side": "awsui_split-panel-side_j4v3w_kfpqx_141"
};
  